import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export default function NewClientModal({ open, onOpenChange, data, onChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nuevo Cliente</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label htmlFor="new-client-name">Nombre *</Label>
            <Input
              id="new-client-name"
              value={data.name}
              onChange={(e) => onChange({ ...data, name: e.target.value })}
              required
              className="mt-1"
              data-testid="new-client-name"
            />
          </div>
          <div>
            <Label htmlFor="new-client-phone">Teléfono *</Label>
            <Input
              id="new-client-phone"
              value={data.phone}
              onChange={(e) => onChange({ ...data, phone: e.target.value })}
              required
              className="mt-1"
              data-testid="new-client-phone"
            />
          </div>
          <div>
            <Label htmlFor="new-client-email">Email (opcional)</Label>
            <Input
              id="new-client-email"
              type="email"
              value={data.email}
              onChange={(e) => onChange({ ...data, email: e.target.value })}
              className="mt-1"
              data-testid="new-client-email"
            />
          </div>
          <Button type="submit" className="w-full" data-testid="save-new-client-btn">
            Guardar Cliente
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
